export default "__VITE_ASSET__CEZ4QduL__"